export const reportsEndpoints = (builder) => ({
    downloadUsersByTradeActivityReport: builder.mutation({
        query: ({ side, comparator, amount, startDate, endDate }) => ({
            url: `/reports/users-by-trade-frequency?=${side || "buyAndSell"}`
                + `&comparator=${comparator || "gt"}`
                + `&amount=${amount || 0}`
                + `&startDate=${startDate || ""}`
                + `&endDate=${endDate || ""}`,
            method: 'post'
        }),
    }),
    downloadUsersByHoldingTypeReport: builder.mutation({
        query: ({ type, partner }) => ({
            url: `/reports/accounts-by-holding-type?type=${type || ""}&partner=${partner || ""}`,
            method: 'post'
        }),
    }),
})